<template>
  <div class="container">
    <span class="error-message">{{ message }}</span>
    <span class="close-icon" @click="$emit('delete-error')">+</span>
  </div>
</template>

<script>
export default {
  name: 'ErrorModal',
  props: {
    message: String
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #cc2f2fdd;
  position: absolute;
  bottom: 50px;
  left: 50px;
  border-radius: 10px;
  max-width: 330px;
}
.close-icon {
  font-size: 36px;
  transform: rotate(45deg);
  color: #ffffff;
  cursor: pointer;
  user-select: none;
}
.error-message {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #ffffff;
  margin-right: 20px;
}
</style>
